import { FC, useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { ITrainControlsResponse } from "../../interfaces";

interface ITiSchemeImageProps {
  control: ITrainControlsResponse;
  flashUnacknowledgedAlarms: boolean;
  flashFaultAlarms: boolean;
}

function pickImageSrc(control: ITrainControlsResponse): string | null {
  const p: any = control.props || {};
  const fromProps = [
    p.SchemeImageDataUrl,
    p.schemeImageDataUrl,
    p.PictureDataUrl,
    p.pictureDataUrl,
    p.PictureURL,
    p.PictureUrl,
    p.ImageURL,
    p.ImageUrl,
    p.URL,
    p.Url,
    p.src,
    p.PicturePath,
    p.FileName,
    p.ImageFile,
    p.Picture,
  ];
  for (const v of fromProps) {
    if (typeof v === "string" && v.trim() !== "") return v.trim();
  }
  const v = control.value;
  if (typeof v !== "string" || v.trim() === "") return null;
  const t = v.trim();
  if (/^https?:\/\//i.test(t) || t.startsWith("data:") || t.startsWith("/") || t.startsWith("./")) return t;
  if (/\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(t)) return t;
  return null;
}

export const TiSchemeImage: FC<ITiSchemeImageProps> = ({ control, flashUnacknowledgedAlarms, flashFaultAlarms }) => {
  const { props, unacknowledgedEvent } = control;
  const src = useMemo(() => pickImageSrc(control), [control]);
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [src]);

  const faultBorder =
    flashFaultAlarms && unacknowledgedEvent === 2
      ? "2px solid #d32f2f"
      : flashUnacknowledgedAlarms && unacknowledgedEvent > 0
        ? "2px solid #ed6c02"
        : "1px solid rgba(0,0,0,0.2)";

  return (
    <Box
      sx={{
        position: "absolute",
        left: props.Left,
        top: props.Top,
        width: props.Width,
        height: props.Height,
        boxSizing: "border-box",
        border: faultBorder,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.04)",
        pointerEvents: "none",
      }}
    >
      {src && !broken ? (
        <Box
          component="img"
          src={src}
          alt=""
          onError={() => setBroken(true)}
          sx={{
            maxWidth: "100%",
            maxHeight: "100%",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            display: "block",
          }}
        />
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            minHeight: 8,
            background: "repeating-linear-gradient(45deg, #e0e0e0, #e0e0e0 4px, #f5f5f5 4px, #f5f5f5 8px)",
          }}
        />
      )}
    </Box>
  );
};
